module.exports = __webpack_public_path__ + "img/message-square.c3b99ee4.svg";